module.exports = __webpack_public_path__ + "assets/img/30_837_big.1dd8ec78.jpg";